export function getLexicalHeadingClassName(tag: string): string {
  switch (tag) {
    case 'h1':
      return 'text-3xl font-bold mb-6 mt-8';
    case 'h2':
      return 'text-2xl font-bold mb-4 mt-6';
    case 'h3':
      return 'text-xl font-bold mb-3 mt-5';
    case 'h4':
      return 'text-lg font-bold mb-2 mt-4';
    case 'h5':
      return 'text-base font-bold mb-2 mt-3';
    case 'h6':
      return 'text-sm font-bold mb-2 mt-2';
    default:
      return 'font-bold mb-2 mt-2';
  }
}
